<template>
    <div class="menu-page">
        <div class="menu-header">
            <img v-if="user.morglogo" :src="user.morglogo" class="header-avatar"/>
            <img v-else class="header-avatar" src="../../../assets/img/defailt-avatar.png"/>
            <div class="header-name">{{ user.morgname }}</div>
        </div>
        <div class="menus">
            <div v-for="(item,index) in menus" :key="index" class="flex flex-direction">
                <div :class="{ active: navIndex[0]  == item.value}"
                             @click="toPage(`${item.page}?t=${new Date().getTime()}`)"
                             class="mune-item">
                    <i :class="[{active: navIndex[0]  == item.value},item.icon]" class="iconfont "></i>
                    <div :class="{ active: navIndex[0]  == item.value}" class="title">{{ item.label }}</div>
                    <i class="expand" :class="[{active: navIndex[0]  == item.value},item.expand ? 'el-icon-arrow-down': 'el-icon-arrow-up']"
                       @click.stop="expand(index)" v-if="item.childs && item.childs.length"></i>
                </div>
                <div v-if="item.childs && item.expand" class="flex flex-direction">
                    <router-link v-for="(child,position) in item.childs" :key="position"
                                 :class="{ active: navIndex[1]  == child.value && navIndex[0]  == item.value}"
                                 :to="`${child.page}?t=${new Date().getTime()}`" class="menu-child">
                        {{ child.label }}
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {organizMenus} from '@/utils/const'
import {emofLogin} from "@/api/login";
import {getSonPower} from "@/api/organiz";

export default {
    name: "MenuOrganizationModular",
    data() {
        return {
            menus: JSON.parse(JSON.stringify(organizMenus)),
            userInfo: ''
        };
    },
    props: {
        navIndex: {},
        upState: {
            type: Boolean,
            default: false
        },
        menu: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.user.sid) this.getSonPower()
        this.menus.map((item,index) => {
            item.expand = false
            item.position = index
            item._position = index
            if (item.childs) item.childs = item.childs.filter(child => {
                return child.role ? child.role === this.user.type : true
            })
        })
    },
    methods: {
        setExpand() {
            this.menus.map(item => {
                item._position = item.value === this.navIndex[0] ? -1 : item.position
                item.expand = item.value === this.navIndex[0]
            })
            // this.menus = this.menus.sort((a,b)=>{
            //    return a._position - b._position
            // })
        },
        expand(index) {
            this.menus[index].expand = !this.menus[index].expand
            this.$forceUpdate()
        },
        toPage(path) {
            this.$router.push(path)
        },
        //  页面加载时请求
        async getSonPower() {
            let _data = await getSonPower(this.user.sid)
            if (_data.data) {
                let _power = _data.data.split(',')
                this.menus.map(item => {
                    item.isShow = _power.some(bol => bol === `${item.value}`)
                    if (item.childs) {
                        item.childs = item.childs.filter(child => {
                            return _power.some(bol => bol === `${item.value}-${child.value}`)
                        })
                    }
                    if (item.isShow && item.childs) {
                        if (item.childs.length === 0) {
                            item.isShow = false
                        } else {
                            item.page = item.childs[0].page
                        }
                    }

                })
                this.menus = this.menus.filter(item => {
                    return item.isShow
                })
            }
        },
        async weixinLogin() {
            let _state = await emofLogin(this.user.emofUserTokenSafer)
            this.$store.state.token = _state.data.token
            this.$store.state.user = _state.data
            await window.localStorage.setItem('token', JSON.stringify(_state.data.token))
            await window.localStorage.setItem('user', JSON.stringify(_state.data))

        },
    },
    watch: {
        upState() {
            if (this.upState) {
                this.weixinLogin()
            }
        },
        navIndex() {
            this.setExpand()
        }
    },
};
</script>

<style lang="scss" scoped>
.menu-page {
    display: flex;
    flex-direction: column;
    width: 170px;
    flex-shrink: 0;

    .menu-header {
        width: 100%;
        min-height: 157px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #0a2240;
        border-radius: 10px;
        padding: 12px 26px;

        .header-avatar {
            width: 85px;
            height: 85px;
            border-radius: 85px;
        }

        .header-name {
            text-align: center;
            font-size: 14px;
            line-height: 18px;
            color: #ffffff;
            margin-top: 12px;
        }
    }

    .menus {
        width: 100%;
        flex: 1;
        background-color: #0a2240;
        box-shadow: 0 6px 16px 1px rgba(10, 34, 64, 0.47);
        border-radius: 10px;
        margin-top: 10px;

        .mune-item {
            height: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: none;
            position: relative;
            cursor: pointer;
            .expand {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 20px;
                color: #ffffff;

                &.active {
                    color: #ff9600;

                }
            }
            &:after {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 1px;
                background: #ffffff33;
                transform: translateY(-50%);
                content: '';
            }

            &.active {
                background: #233953;
                border-radius: 10px;

                &:before {
                    position: absolute;
                    right: -8px;
                    border-top: 8px solid transparent;
                    border-left: 8px solid #233953;
                    border-bottom: 8px solid transparent;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                }
            }

            .title {
                font-size: 18px;
                color: #ffffff;
                margin-top: 10px;

                &.active {
                    color: #ff9600;

                }
            }

            i {
                font-size: 30px;
                color: #ffffff;

                &.active {
                    color: #ff9600;

                }
            }
        }

        .menu-child {
            width: 100%;
            height: 58px;
            font-size: 18px;
            line-height: 58px;
            color: #ffffff;
            padding-left: 60px;
            background: #233953;
            border-bottom: 1px solid #ffffff33;

            &.active {
                position: relative;
                color: #ffa11a;

                &:before {
                    position: absolute;
                    width: 3px;
                    height: 17px;
                    background-color: #ff9600;
                    border-radius: 2px;
                    left: 48px;
                    top: 50%;
                    transform: translateY(-50%);
                    content: '';
                }
            }
        }
    }

}
</style>
